import type { ReactNode } from 'react';

export const symbol_tab_close: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-200q-24 0-42-18t-18-42v-560q0-24 18-42t42-18h560q24 0 42 18t18 42v560q0 24-18 42t-42 18H260Zm0-60h560v-560H260v560ZM140-80q-24 0-42-18t-18-42v-590q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v590h590q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q742.75-80 730-80H140Zm120-740v560-560Zm217 385 63-63 63 63q9 9 21 9t21-9q9-9 9-21t-9-21l-63-63 63-63q9-9 9-21t-9-21q-9-9-21-9t-21 9l-63 63-63-63q-9-9-21-9t-21 9q-9 9-9 21t9 21l63 63-63 63q-9 9-9 21t9 21q9 9 21 9t21-9Z"
		/>
	</svg>
);
